import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {BymoPagePropsSpecialContentSettingMetadata} from '../../client-server-common';
import type {DoppeLinkSpec} from '../../client-server-common/types/doppe-action-cta-button';
import {
    DoppeActionCTATypeLinkOpenType,
    doppeLinkSpecCreateDefault,
    doppeLinkSpecResolveBusinessEntityReference
} from '../../client-server-common/types/doppe-action-cta-button';
import {arrayRemoveNullValues} from '@wix/devzai-utils-common';
import {doppeLinkSpecResolveToUrl} from '../doppe-actions-common/doppe-cta-button-utils/doppe-cta-button-utils';


export namespace DoppeActionTypeLink {

    export interface ActionSettings {
        /**
         * Link specification - can be a URL string, a page reference, or an entity reference.
         * Previously was just a string URL, now supports DoppeLinkSpec for page/entity links.
         */
        url: DoppeLinkSpec;
        /**
         * How the link should open (new tab, same tab, or in-page modal).
         */
        openType: DoppeActionCTATypeLinkOpenType;
    }
}

export const doppeActionTypeLink = doppeActionTypeDefineMetadata<DoppeActionTypeLink.ActionSettings>({
    id: 'io.bymo.action/link',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        url: doppeLinkSpecCreateDefault(),
        openType: DoppeActionCTATypeLinkOpenType.SameTab,
    }),
    resolveMainLink: (actionSettings, htmlSiteInfo, _viewerLang, bymoPageProps, viewerPagesRoutesManager) => {
        // Use the common function to resolve DoppeLinkSpec to URL
        // This handles URL strings, Page links, and Entity links
        return doppeLinkSpecResolveToUrl(actionSettings.url, {
            htmlSiteInfo: htmlSiteInfo,
            bymoPageProps: bymoPageProps,
            viewerPagesRoutesManager: viewerPagesRoutesManager
        }) ?? null;
    },
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            url: BymoPagePropsSpecialContentSettingMetadata.ToBeConsidered,
            openType: BymoPagePropsSpecialContentSettingMetadata.ToBeConsidered
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false,
    hasNoLockInnerCTA: true,
    resolveUsedBusinessEntities: actionSettings => {
        return arrayRemoveNullValues([
            doppeLinkSpecResolveBusinessEntityReference(actionSettings.url)
        ]);
    },
})